import { t } from "i18next";
import { ComputeFieldComponent } from "../../computeFields";
import { ArtworkRelation, Author } from "../../types";
import { ComponentProps } from "react";
import { SeparatedList } from "./utils";

const getRelatedAuthorDetails: ComputeFieldComponent<
  Pick<
    Author,
    | "artistesAuteursDescriptionPrenom"
    | "artistesAuteursDescriptionNom"
    | "artistesAuteursDescriptionResumeDates"
    | "artistesAuteursDescriptionPaysDActivite"
  > & {
    relation: ArtworkRelation;
  }
> = ({ input: { relation, ...author }, language: forceLang }) => {
  const authorName = `${author.artistesAuteursDescriptionPrenom}${" "}${author.artistesAuteursDescriptionNom}${" "}${author.artistesAuteursDescriptionResumeDates != undefined && author.artistesAuteursDescriptionResumeDates !== "" ? `(${author.artistesAuteursDescriptionResumeDates})` : ""}`;

  if (relation.attributedTo) {
    return `${authorName} (${t("computeField.attribueA", { lng: forceLang })})`;
  }

  if (relation.from) {
    return `${authorName} (${t("computeField.dApres", { lng: forceLang })})`;
  }

  if (relation.tasteOf) {
    return `${authorName} (${t("computeField.dansLeGoutDe", { lng: forceLang })})`;
  }

  if (relation.entourageOf) {
    return `${authorName} (${t("computeField.entourageDe", { lng: forceLang })})`;
  }

  if (relation.studioOf) {
    return `${authorName} (${t("computeField.atelierDe", { lng: forceLang })})`;
  }

  return <>{authorName}</>;
};

export const RelatedAuthorsListCF: ComputeFieldComponent<
  {
    relatedAuthors: Omit<
      ComponentProps<typeof getRelatedAuthorDetails>["input"],
      "relation"
    >[];
    anonymous?: boolean;
  } & ArtworkRelation
> = ({ input, lineBreak = false, ...props }) => {
  if (input.relatedAuthors == undefined || input.relatedAuthors.length === 0) {
    return "";
  }

  if (input.anonymous) {
    return t("computeField.anonyme", { lng: props.language });
  }

  const authorList = input.relatedAuthors.map((author) =>
    getRelatedAuthorDetails({
      input: {
        ...author,
        relation: {
          attributedTo: input.attributedTo,
          from: input.from,
          tasteOf: input.tasteOf,
          entourageOf: input.entourageOf,
          studioOf: input.studioOf,
        },
      },
      ...props,
    }),
  );

  return <SeparatedList input={authorList} lineBreak={lineBreak} {...props} />;
};
